import { nonBusinessApiError } from 'scenes/payments/components/Errors/helper/errorHandling';
import { PaymentState } from '../../types';

export const getPaymentState = (state: { payment: PaymentState }) =>
  state.payment;

export const getLoadingStatus = (state: { payment: PaymentState }) =>
  getPaymentState(state).loadingStatus;

export const getErrorState = (state: { payment: PaymentState }) =>
  getPaymentState(state).error?.error;

export const getContextErrorOccuredAt = (state: { payment: PaymentState }) =>
  getPaymentState(state).error?.errorOccuredAt ?? '';

export const getIsSystemErrorState = (state: { payment: PaymentState }) => {
  const error = getErrorState(state);
  const loadingStatus = getLoadingStatus(state);
  return nonBusinessApiError(loadingStatus, error);
};

export const getPolicyNumber = (state: { payment: PaymentState }) =>
  getPaymentState(state).policy.number;

export const getPolicyPostcode = (state: { payment: PaymentState }) =>
  getPaymentState(state).policy.number;

export const getProductType = (state: { payment: PaymentState }) =>
  getPaymentState(state).product;

export const getProductDescription = (state: { payment: PaymentState }) =>
  getPaymentState(state).policy.otherDetails.description;

export const getPaymentMethod = (state: { payment: PaymentState }) =>
  getPaymentState(state).payment?.paymentMethod ?? '';

export const getRiskPostcode = (state: { payment: PaymentState }) =>
  getPaymentState(state).policy.postcode ?? '';

export const getCurrentErrorCode = (state: { payment: PaymentState }) =>
  getErrorState(state)?.data?.code ?? '';

export const getCurrentHttpErrorCode = (state: { payment: PaymentState }) =>
  getErrorState(state)?.httpCode ?? '';

export const getCurrentErrorMsg = (state: { payment: PaymentState }) =>
  getErrorState(state)?.message ?? '';

export const getPaymentWhen = (state: { payment: PaymentState }) =>
  getPaymentState(state).payment.paymentWhen;

export const getPaymentType = (state: { payment: PaymentState }) =>
  getPaymentState(state).policy.renewalStatus;

export const getEffectiveDate = (state: { payment: PaymentState }) =>
  getPaymentState(state).policy.dates?.effective;
